/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';



import { Configuration }                                     from '../configuration';



export interface LabelTranslationServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Returns label translations list
     * Returns label translations for a specific language code
     * @param languageCode language code for translation
     */
    getLabelTranslationByLanguageCode(languageCode: string, extraHttpRequestParams?: any): Observable<{ [key: string]: string; }>;

}
